import Button from "../gui/Button/Button";
import AccountIcon from "../gui/Icons/AccountIcon";
import {useLogin} from "../gui/Login/LoginProvider";

export default function LoginButton(){
    const {login} = useLogin()
    return <Button size="medium" variant="contained" color="primary" onClick={e => login()}><AccountIcon/> Login</Button>
}